module.exports = __webpack_public_path__ + "static/media/dublin-city-council.63327b96.png";